import React from "react";
import Modal from "./modal";

export default function StatusChoiceModal({ show, currentStatus, onSelect, onClose }) {

  function getOptions() {
    switch (currentStatus) {
      case "Vêlage":
        return ["Oestrus", "Saillie" , "Supprimer événement"];
      case "Oestrus":
        return ["Diagnostic" , "Supprimer événement"];
      case "Saillie":
        return ["Diagnostic" , "Supprimer événement"];
      case "Gestation":
        return ["Repos","Vêlage","Avortement", "Supprimer événement"];
      case "Repos":
        return ["Vêlage","Avortement", "Supprimer événement"];
      case "Avortement":
        return ["Saillie","Oestrus", "Supprimer événement"];
      default:
        return ["Oestrus", "Saillie"];
    }
  }

  const options = getOptions();

  return (
    <Modal show={show} onClose={onClose}>
      <h2>Choisir prochaine étape</h2>
      {options.map((op, i) => (
        <button
          key={i}
          style={{ padding: "10px", margin: "10px", cursor: "pointer" }}
          onClick={() => onSelect(op)}
        >
          {op}
        </button>
      ))}
    </Modal>
  );
}
